import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SessionCompany } from '@core/auth/auth-session.model';
import { setCreateBusinessIntent } from '@core/auth/create-business-intent.storage';
import { LocationContextService } from '@core/tenant/location-context.service';
import { TenantContextService } from '@core/tenant/tenant-context.service';
import { TenantCompanySwitchService } from '@core/tenant/tenant-company-switch.service';
import {
  WorkspacePickerDialogComponent,
  WorkspacePickerDialogData,
  WorkspacePickerDialogResult,
} from './workspace-picker-dialog.component';

export function openWorkspacePickerAndApply(
  dialog: MatDialog,
  options: {
    companies: SessionCompany[];
    activeCompanyId: number | null;
    allowCreateBusiness?: boolean;
    switchService: TenantCompanySwitchService;
    router: Router;
    tenantContext: TenantContextService;
    locationContext: LocationContextService;
  }
): void {
  const ref = dialog.open<
    WorkspacePickerDialogComponent,
    WorkspacePickerDialogData,
    WorkspacePickerDialogResult
  >(WorkspacePickerDialogComponent, {
    width: 'min(420px, calc(100vw - 2rem))',
    maxWidth: '95vw',
    autoFocus: 'dialog',
    panelClass: 'workspace-picker-dialog-panel',
    data: {
      companies: options.companies,
      activeCompanyId: options.activeCompanyId,
      allowCreateBusiness: options.allowCreateBusiness ?? true,
    },
  });

  ref.afterClosed().subscribe((result) => {
    if (!result) {
      return;
    }
    if (result.action === 'switch') {
      options.switchService.switchCompany(result.companyId);
      return;
    }
    if (result.action === 'create_business') {
      setCreateBusinessIntent();
      options.tenantContext.clear();
      options.locationContext.clear();
      void options.router.navigate(['/onboard'], { replaceUrl: true });
    }
  });
}
